import React, {
  Fragment,
  useRef,
  useState,
  useEffect,
} from 'react';
import {
  Row,
  Col,
  Form,
  Modal,
  Input,
  Button,
  Select,
  message,
  PageHeader,
} from 'antd';
import BrandModal from './components/brandModal';
import { TableView } from 'components';
import { DoubleRightOutlined } from '@ant-design/icons';
import { controllerProdCenter } from 'controller';

const { Option } = Select;
const confirm = Modal.confirm;

function Brand() {
  const modalRef1 = useRef(null);
  const [form] = Form.useForm();
  const [list, setList] = useState([]);
  const [total, setTotal] = useState(0);
  const [searchObj, setSearchObj] = useState({ code: '', name: '', active: undefined, p: 1, s: 10 });
  const [isLoading, setIsLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      const res = await controllerProdCenter.brand.list(searchObj);
      setIsLoading(false);
      setList(res.data || []);
      setTotal(res.total || 0);
      res.code !== __SUCCESS__ && res.code !== __SUCCESS200__ && message.error(res.msg);
    };
    fetchData();
  }, [searchObj]);
  const handleClick = () => {
    setShowForm(!showForm);
  };
  const setBrandState = (record) => {
    controllerProdCenter.brand.saveOrUpdate({
      ...record,
      active: record.active === 1 ? 0 : 1, // 状态：1-启用；2-禁用
    }).then(res => {
      res.code === __SUCCESS200__ && setSearchObj({ ...searchObj });
      res.code !== __SUCCESS200__ && message.error(res.msg);
    });
  };
  const optClickHandle = (record, act) => {
    switch (act) {
      case 'edit':
        modalRef1.current.showModal(record);
        break;
      case 'valid': // 启用/禁用
        setBrandState(record);
        break;
      case 'delete':
        confirm({
          title: '是否删除该条数据？',
          //content: 'Some descriptions',
          okText: '是',
          okType: 'danger',
          cancelText: '否',
          onOk() {
            controllerProdCenter.brand.delete({id: record.id}).then(res => {
              res.code === __SUCCESS200__ && setSearchObj({ ...searchObj });
              res.code !== __SUCCESS200__ && message.error(res.msg);
            })
          },
          onCancel() {
            console.log('cancel');
          }
        });
        break;
      default:
        break;
    }
  };
  const pageChange = (page, pageSize) => {
    setSearchObj({
      ...searchObj,
      p: page,
      s: pageSize,
    });
  };
  const onSearch = (values) => {
    setSearchObj({
      ...searchObj,
      ...values,
      p: 1,
    });
  };
  const resetSearch = () => {
    setSearchObj(data => ({
      ...data,
      code: '',
      name: '',
      active: undefined,
      page: 1,
    }));
    form.setFieldsValue({
      code: '',
      name: '',
      active: undefined,
    });
  };
  const tableProps = {
    rowKey: 'id',
    loading: isLoading,
    columns: [
      {
        title: '代码',
        dataIndex: 'code',
        key: 'code',
      },
      {
        title: '名称',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: '排序',
        dataIndex: 'sortOrder',
        key: 'sortOrder',
      },
      {
        title: '有效性',
        dataIndex: 'active',
        key: 'active',
        width: 80,
        render: (val) => (val === 1 ? '启用' : '禁用'),
      },
      {
        title: '创建人',
        dataIndex: 'createdName',
        key: 'createdName',
      },
      {
        title: '创建时间',
        dataIndex: 'createdDate',
        key: 'createdDate',
      },
      {
        title: '操作',
        width: 200,
        align: 'center',
        render: (val, record, index) => <Fragment>
          <Button type="link" onClick={() => optClickHandle(record, 'edit')}>编辑</Button>
          <Button type="link"
                  onClick={() => optClickHandle(record, 'valid')}>{record.active === 1 ? '禁用' : '启用'}</Button>
          <Button type="link" onClick={() => optClickHandle(record, 'delete')}>删除</Button>
        </Fragment>,
      },
    ],
    rows: list,
    pageParam: {
      total: total,
      current: searchObj.p,//当前页码
      pageSize: searchObj.s,//当前分页数
      onChange: pageChange,
    },
  };
  return <Fragment>
    <div className="app-body">
      <PageHeader
        ghost={false}
        className="gray-header"
        title={<Button type="gray" onClick={() => modalRef1.current.showModal()}>新增</Button>}
        extra={[
          <Button className="pos-bottom"
                  key="1"
                  onClick={handleClick}
                  icon={<DoubleRightOutlined rotate={showForm ? 270 : 90} />}>{showForm ? '关闭查询' : '展开查询'}</Button>,
        ]}
      />
      <Form
        form={form}
        name="basic"
        className="top-search-box"
        style={{ display: showForm ? 'block' : 'none' }}
        initialValues={searchObj}
        onFinish={onSearch}
      >
        <Row gutter={16}>
          <Col span={6}>
            <Form.Item
              label="品牌名称"
              name="name"
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              label="品牌代码"
              name="code"
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              label="有效性"
              name="active"
            >
              <Select>
                <Option value={1}>启用</Option>
                <Option value={0}>禁用</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={6} style={{ textAlign: 'right' }}>
            <Button type="danger" htmlType="submit">
              搜索
            </Button>
            &emsp;
            <Button onClick={resetSearch} style={{ margin: '0 8px' }}>
              重置
            </Button>
          </Col>
        </Row>
      </Form>
      <div className="page-main-box">
        <TableView {...tableProps} />
      </div>
    </div>
    <BrandModal ref={modalRef1} refreshList={onSearch}></BrandModal>
  </Fragment>;
}

export default Brand;
